export const SET_USER = 'SET_USER'
export const CLEAR_USER = "CLEAR_USER"
export const SET_MESSAGE = 'SET_MESSAGE'